exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-link {\r\n  cursor:pointer;\r\n}\r\n\r\n::ng-deep .modal-dialog { \r\n     max-width: 90%;\r\n     width: 90%;\r\n     margin:auto;\r\n}\r\n\r\n::ng-deep .pull-right{\r\n  float: right;;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/user/Desktop/rohini_india/angular/Srilanka-eta.org.lk/src/app/home/home.component.css
// module id = ../../../../../src/app/home/home.component.css
// module chunks = main